import React, { useEffect, useMemo, useRef, useState } from 'react'
import AddOrder from './../modal/AddOrder'
import OrderDetails from './../modal/OrderDetails'
import EyeIcon from './../assets/images/eye.svg'
import { useDeleteOrder, useGetAllOrder, useGetHtmlContent } from '../hooks/hooks';
import Skeleton from 'react-loading-skeleton';
import { getAllOrder } from '../API/order';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import debounce from "lodash/debounce";
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import edit from './../assets/images/edit.png';
import deleteicon from './../assets/images/delete.svg';
import { showErrorToast, showSuccessToast } from '../components/common';
import { ChartIcon, ClearIcon, DropDownArrowIcon, DropdownIcon, FilterIcon, LowStockIcon, NDOrderI, PlusIcon, PrintIcon, SearchIcon } from '../assets/icons/icon';
import { ButtonWithIcon } from '../components/Common/Buttons';
import Header from '../components/Common/Header';
import NoDataFound from '../components/Common/NoDataFound';
import InputSearch from '../components/Common/InputSearch';

const Orders = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [selectedStatus, setselectedStatus] = useState(0);

  const statusList = [
    { id: 0, name: 'All' },
    { id: 1, name: 'In-progress' },
    { id: 2, name: 'Completed' },
    { id: 3, name: 'Upcoming' },
    { id: 4, name: 'Deleted' }
  ];

  const getStartDate = () => {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    return date;
  };

  const getEndDate = (startDate) => {
    const endDate = new Date(startDate);
    endDate.setMonth(endDate.getMonth() + 1);

    if (endDate.getDate() < startDate.getDate()) {
      endDate.setDate(0);
    }

    return endDate;
  };

  const [startDate, setStartDate] = useState(getStartDate());
  const [endDate, setEndDate] = useState(getEndDate(startDate));
  const [searchText, setSearchText] = useState('');
  const normalizedSearchText = searchText.trim();

  const { data: orderList, refetch, isLoading: IsLoading } = useGetAllOrder({
    startDate,
    endDate,
    selectedStatus,
    searchText: normalizedSearchText
  }, {
    enabled: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity
  });

  const { mutate: deleteOrder } = useDeleteOrder();
  const { mutate: getHtmlContent } = useGetHtmlContent();

  const [isPopupOpen, setPopupOpen] = useState(false);
  const [isOrderDetailsPopupOpen, setOrderDetailsPopupOpen] = useState(false);

  const [allOrderList, setAllOrderLit] = useState(orderList);
  const [filteredOrderList, setFilteredOrderList] = useState(orderList);
  const searchInitializedRef = useRef(false);
  const debouncedSearchRefetch = useMemo(
    () =>
      debounce(() => {
        refetch();
      }, 500),
    [refetch]
  );
  const [selectedOrder, setSelectedOrder] = useState(null);

  const [isEdit, setIsEdit] = useState(false);
  const [isEditItem, setIsEditItem] = useState(undefined);
  const [isDeleteOrder, setIsDeleteOrder] = useState(undefined);
  const [isOpenDelete, setisOpenDelete] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [lang, setlang] = useState(localStorage.getItem('i18nextLng'));
  const [htmlContent, setHtmlContent] = useState("");
  const printRef = useRef(null);
  const [isFiltersExpanded, setIsFiltersExpanded] = useState(false);

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    OnFilter();
  }, [selectedStatus]);

  useEffect(() => {
    if (!searchInitializedRef.current) {
      searchInitializedRef.current = true;
      return;
    }

    debouncedSearchRefetch();

    return () => {
      debouncedSearchRefetch.cancel();
    };
  }, [searchText, debouncedSearchRefetch]);

  useEffect(() => {
    if (orderList) {
      setAllOrderLit(orderList);
      setFilteredOrderList(orderList);
    }
  }, [orderList]);

  const handleOpenPopup = () => {
    setPopupOpen(true);
  };

  const handleClosePopup = async (isRefresh) => {
    setPopupOpen(false);
    setIsEdit(false);
    setIsEditItem(undefined);
    if (isRefresh) {
      const order = await getAllOrder({
        startDate,
        endDate,
        selectedStatus,
        searchText: normalizedSearchText,
      });
      setAllOrderLit(order.data.data);
      setFilteredOrderList(order.data.data);
    }
  };

  const handleOpenOrderDetailsPopup = () => {
    setOrderDetailsPopupOpen(true);
  };

  const handleCloseOrderDetailsPopup = async (isRefresh) => {
    setOrderDetailsPopupOpen(false);
    setSelectedOrder(null);
    if (isRefresh) {
      const ALLoRDER = await getAllOrder({
        startDate,
        endDate,
        selectedStatus,
        searchText: normalizedSearchText,
      });

      setAllOrderLit(ALLoRDER.data.data);
      setFilteredOrderList(ALLoRDER.data.data);
    }
  };

  const onDeleteClose = (isDelete) => {
    if (isDelete) {
      handleDeleteOrder(isDeleteOrder);
    }
    setisOpenDelete(false)
  }

  const handleDeleteOrder = (item) => {
    deleteOrder(item, {
      onSuccess: async (res) => {
        refetch();
        showSuccessToast(res?.data?.message);
      },
      onError: (err) => {
        showErrorToast(err.response.data.error)
      },
    });
  };

  const OnFilter = () => {

    const startdate = new Date(startDate);
    const enddate = new Date(endDate);

    if (isNaN(startdate.getTime())) {
      showErrorToast(t('Start_Date_Er'));
      return;
    }

    if (isNaN(enddate.getTime())) {
      showErrorToast(t('End_Date_Er'));
      return;
    }

    if (startdate > enddate) {
      showErrorToast(t('Start_End_Date_Er'));
      return;
    }
    refetch();

    // const filteredOrders = allOrderList.filter(order => {
    //   const orderDate = new Date(order.eventDate);
    //   return orderDate >= startdate && orderDate <= enddate;
    // });

    // setFilteredOrderList(filteredOrders)
  }

  const handleSelect = (event, id) => {
    if (event.target.checked) {
      setSelectedIds((prev) => [...prev, id]);
    } else {
      setSelectedIds((prev) => prev.filter((item) => item !== id));
    }
  };

  const handleGetPrintConetent = () => {
    getHtmlContent({ selectedIds, lang }, {
      onSuccess: (res) => {
        if (res?.data?.htmlContent) {
          handlePrint(res.data.htmlContent);
        }
      },
      onError: (err) => {
      },
    });
  }

  const handlePrint = (htmlContent) => {
    const printWindow = window.open("", "_blank");
    printWindow.document.open();
    printWindow.document.write(htmlContent);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
  };

  const getStatusColor = (statusId) => {
    const statusColors = {
      0: "#6B7280",
      1: "#FF0000",
      2: "#10B981",
      3: "#3B82F6",
      4: "#F59E0B"
    };
    return statusColors[statusId] || "#D1D5DB";
  };

  const getStatusName = (statusId) => {
    const statusNames = {
      0: t('all'),
      1: t('inprogress'),
      2: t('completed'),
      3: t('upcoming'),
      4: t('deleted')
    };
    return statusNames[statusId] || t('status.unknown');
  };

  const getStatusClass = (statusId) => {
    const statusClasses = {
      0: "bg-gray-100 text-gray-800",
      1: "bg-red-100 text-red-800",
      2: "bg-green-100 text-green-800",
      3: "bg-blue-100 text-blue-800",
      4: "bg-yellow-100 text-yellow-800",
    };
    return statusClasses[statusId] || "bg-gray-100 text-gray-800";
  };

  const getRandomIcon = (index, status) => {
    const icons = [
      // Calendar icon
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>,
      // Shopping bag icon
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
      </svg>,
      // Package icon
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
      </svg>,
      // Document icon
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>,
      // Receipt icon
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>,
      // Clipboard icon
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
      </svg>,
      // Tag icon
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
      </svg>,
      // Gift icon
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
      </svg>
    ];

    // Map status to enhanced styling with backgrounds, borders, and shadows
    const statusStyles = {
      0: {
        bg: 'bg-gradient-to-br from-gray-50 to-gray-100',
        border: 'border-2 border-gray-300',
        text: 'text-gray-700',
        shadow: 'shadow-md shadow-gray-200/50'
      },
      1: {
        bg: 'bg-gradient-to-br from-red-50 to-red-100',
        border: 'border-2 border-red-400',
        text: 'text-red-700',
        shadow: 'shadow-md shadow-red-200/50'
      },
      2: {
        bg: 'bg-gradient-to-br from-green-50 to-green-100',
        border: 'border-2 border-green-400',
        text: 'text-green-700',
        shadow: 'shadow-md shadow-green-200/50'
      },
      3: {
        bg: 'bg-gradient-to-br from-blue-50 to-blue-100',
        border: 'border-2 border-blue-400',
        text: 'text-blue-700',
        shadow: 'shadow-md shadow-blue-200/50'
      },
      4: {
        bg: 'bg-gradient-to-br from-yellow-50 to-yellow-100',
        border: 'border-2 border-yellow-400',
        text: 'text-yellow-700',
        shadow: 'shadow-md shadow-yellow-200/50'
      }
    };

    const iconIndex = index % icons.length;
    const statusId = status !== undefined ? status : 0;
    const style = statusStyles[statusId] || statusStyles[0];

    return (
      <div className={`w-14 h-14 rounded-xl flex items-center justify-center ${style.bg} ${style.border} ${style.shadow} transition-all duration-300 hover:scale-110 hover:shadow-lg`}>
        <div className={style.text}>
          {icons[iconIndex]}
        </div>
      </div>
    );
  };

  const getCardBackground = (status) => {
    const cardStyles = {
      0: {
        bg: 'bg-gradient-to-br from-white to-gray-50/50',
        border: 'border-gray-200/80',
        hover: 'hover:from-white hover:to-gray-50'
      },
      1: {
        bg: 'bg-gradient-to-br from-red-50/30 to-red-50/10',
        border: 'border-red-200/60',
        hover: 'hover:from-red-50/40 hover:to-red-50/20'
      },
      2: {
        bg: 'bg-gradient-to-br from-green-50/30 to-green-50/10',
        border: 'border-green-200/60',
        hover: 'hover:from-green-50/40 hover:to-green-50/20'
      },
      3: {
        bg: 'bg-gradient-to-br from-blue-50/30 to-blue-50/10',
        border: 'border-blue-200/60',
        hover: 'hover:from-blue-50/40 hover:to-blue-50/20'
      },
      4: {
        bg: 'bg-gradient-to-br from-yellow-50/30 to-yellow-50/10',
        border: 'border-yellow-200/60',
        hover: 'hover:from-yellow-50/40 hover:to-yellow-50/20'
      }
    };
    const statusId = status !== undefined ? status : 0;
    return cardStyles[statusId] || cardStyles[0];
  };

  return (
    <>
      <div className="min-h-screen bg-gray-50">
        {/* Header Section */}
        {/* <div className="mx-auto px-6 py-6">
            <div className="flex flex-row items-center justify-between gap-4">
              <div>
                <h1 className="text-3xl font-bold text-gray-900">{t('order')}</h1>
                <p className="text-gray-600 mt-1">{t('manage_track_orders')}</p>
              </div>

              <div className="flex items-center gap-3">
                {selectedIds.length > 0 && (
                  <button
                    className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-lg text-white bg-primary hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-colors duration-200"
                    onClick={handleGetPrintConetent}
                  >
                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                    </svg>
                    {t('printMaterial')}
                  </button>

                )}
              </div>
            </div>
          </div> */}
        <Header title={t('order')} subTitle={t('manage_track_orders')} buttonText={t('add_new_order')} handleClick={handleOpenPopup} className='px-6 py-6 mb-0' btnclass='px-4 py-2' actions={
          selectedIds.length > 0 && (
            <ButtonWithIcon text={t('printMaterial')} onClick={handleGetPrintConetent} Icon={PrintIcon} btnclass='px-4 py-2' />
          )
        } />

        {/* Filters Section */}
        <div className="mx-auto px-6 ">
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden mb-4">
            {/* Collapsible Header */}
            <div
              className="px-6 py-4 cursor-pointer hover:bg-gray-50 transition-colors duration-200"
              onClick={() => setIsFiltersExpanded(!isFiltersExpanded)}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <button className="p-1 rounded-lg hover:bg-gray-200 transition-colors duration-200">
                    <DropDownArrowIcon className={`w-5 h-5 ${isFiltersExpanded ? 'rotate-90' : ''}`} />
                  </button>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900">{t('filters_search')}</h3>
                    <p className="text-sm text-gray-600 mt-1">{t('refine_order_list')}</p>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  {/* Active Filters Summary */}
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <ChartIcon />
                    <span>{filteredOrderList?.length || 0} {t('orders_found')}</span>
                  </div>
                  <ButtonWithIcon text={t('btn_clear')} btnclass='px-3 py-1.5 text-xs' Icon={ClearIcon} onClick={(e) => {
                    e.stopPropagation();
                    setStartDate(getStartDate());
                    setEndDate(getEndDate(getStartDate()));
                    setselectedStatus(0);
                    setSearchText('');
                    setFilteredOrderList(allOrderList);
                  }} variant='outline' />
                </div>
              </div>
            </div>

            {/* Collapsible Content */}
            <div className={`transition-all duration-300 ease-in-out ${isFiltersExpanded ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
              <div className="px-6 pb-6">
                {/* Filters Grid */}
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
                  {/* Date Range */}
                  <div className="lg:col-span-6">
                    <label className="block text-sm font-medium text-gray-700 mb-3">{t('date_range_label')}</label>
                    <div className="flex items-center gap-3">
                      <div className="flex-1">
                        <DatePicker
                          className="w-full h-11 px-4 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary/20 focus:border-primary transition-colors duration-200"
                          selected={startDate}
                          onChange={(date) => setStartDate(date)}
                          dateFormat="dd-MM-yyyy"
                          placeholderText="Start date"
                        />
                      </div>
                      <div className="flex items-center">
                        <span className="text-gray-500 text-sm font-medium">{t('to')}</span>
                      </div>
                      <div className="flex-1">
                        <DatePicker
                          className="w-full h-11 px-4 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary/20 focus:border-primary transition-colors duration-200"
                          selected={endDate}
                          onChange={(date) => setEndDate(date)}
                          dateFormat="dd-MM-yyyy"
                          placeholderText="End date"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Status and Search Row */}
                  <div className="lg:col-span-6">
                    <div className="grid grid-cols-2 gap-4">
                      {/* Status Filter */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-3">{t('status')}</label>
                        <div className="relative">
                          <select
                            name="status"
                            value={selectedStatus}
                            onChange={(e) => {
                              setselectedStatus(e.target.value);
                            }}
                            className="w-full h-11 px-4 text-sm border border-gray-300 rounded-lg focus:ring-primary appearance-none bg-white focus-within:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all duration-200 focus-within:outline-0"
                          >
                            <option value="" disabled>Select status</option>
                            {statusList && statusList.map((status) => (
                              <option key={status.id} value={status.id}>
                                {status.name}
                              </option>
                            ))}
                          </select>
                          <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                            <DropdownIcon />
                          </div>
                        </div>
                      </div>

                      {/* Search */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-3">{t('search_label')}</label>
                        {/* <div className="relative">
                          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <SearchIcon className="text-primary" />
                          </div>
                          <input
                            type="text"
                            value={searchText}
                            onChange={(e) => {
                              setSearchText(e.target.value);
                            }}
                            placeholder={t('search_lbl')}
                            className="w-full h-11 pl-10 pr-4 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary transition-colors duration-200"
                          />
                        </div> */}
                        <InputSearch className="max-w-auto" searchText={searchText} onSearchChange={setSearchText} placeholder={t('search_lbl')} inputClass='text-sm py-2 h-11' />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex items-center justify-between mt-6 pt-6 border-t border-gray-200">
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <ChartIcon />
                    <span>{filteredOrderList?.length || 0} {t('orders_found')}</span>
                  </div>

                  <div className="flex items-center gap-3">
                    <ButtonWithIcon text={t('apply_filters')} onClick={OnFilter} Icon={FilterIcon} btnclass='' variant='outline' />

                    <ButtonWithIcon text={t('search_btn')} onClick={OnFilter} Icon={SearchIcon} btnclass='bg-primary text-white hover:bg-primary/90 border-0' variant='outline' iconClass='text-white' />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Orders Grid */}
          {/* <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden"> */}
          <div className="overflow-x-auto">
            {/* <div className="px-6 py-4 border-b border-gray-200 bg-gray-50">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-semibold text-gray-900">
                  {t('orders')} ({filteredOrderList?.length || 0})
                </h3>
                <div className="flex items-center gap-3">
                  {selectedIds.length > 0 && (
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-primary text-white">
                      {selectedIds.length} {t('selected')}
                    </span>
                  )}
                  {filteredOrderList && filteredOrderList.length > 0 && (
                    <label className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer">
                      <input 
                        type="checkbox" 
                        className="w-4 h-4 text-primary border-gray-300 rounded focus:ring-primary"
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedIds(filteredOrderList?.map(item => item._id) || []);
                          } else {
                            setSelectedIds([]);
                          }
                        }}
                        checked={selectedIds.length === filteredOrderList?.length && filteredOrderList?.length > 0}
                      />
                      <span>{t('select_all')}</span>
                    </label>
                  )}
                </div>
              </div>
            </div> */}

            <div className="p-0">
              {IsLoading ? (
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                  {Array.from({ length: 6 }, (_, index) => (
                    <div key={index} className="bg-gradient-to-br from-white to-gray-50/50 border border-gray-200/80 rounded-lg p-6 shadow-sm">
                      <div className="flex items-start justify-between mb-4">
                        <div className="flex items-center gap-3 flex-1">
                          <Skeleton height={56} width={56} className="rounded-xl" />
                          <Skeleton height={24} width={120} />
                        </div>
                        <Skeleton height={20} width={20} />
                      </div>
                      <Skeleton height={20} width="80%" className="mb-3" />
                      <Skeleton height={20} width="60%" className="mb-3" />
                      <Skeleton height={20} width="70%" className="mb-4" />
                      <div className="flex gap-2 justify-end">
                        <Skeleton height={36} width={36} />
                        <Skeleton height={36} width={36} />
                        <Skeleton height={36} width={36} />
                      </div>
                    </div>
                  ))}
                </div>
              ) : filteredOrderList && filteredOrderList.length > 0 ? (
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                  {filteredOrderList.map((item, index) => (
                    <div
                      key={item._id || index}
                      className={`${getCardBackground(item.status).bg} border ${getCardBackground(item.status).border} rounded-lg p-6 shadow-sm hover:shadow-lg transition-all duration-200 ${getCardBackground(item.status).hover}`}
                    >
                      {/* Card Header */}
                      <div className="flex items-start justify-between mb-4">
                        <div className="flex items-center gap-3 flex-1">
                          {/* Icon with square background */}
                          {getRandomIcon(index, item.status)}

                          <div className="flex-1">
                            <div className="flex items-center gap-2 mb-1">
                              <span className="text-xs font-medium text-gray-500">#{index + 1}</span>
                              <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusClass(item.status)}`}>
                                {item.order_id}
                              </span>
                              <div
                                className="w-2.5 h-2.5 rounded-full flex-shrink-0 shadow-sm"
                                style={{ backgroundColor: getStatusColor(item.status) }}
                                title={getStatusName(item.status)}
                              />
                            </div>
                          </div>
                        </div>

                        {/* Checkbox on the right */}
                        <input
                          type="checkbox"
                          className="w-4 h-4 text-primary border-gray-300 rounded focus:ring-primary flex-shrink-0 mt-1"
                          onChange={(e) => handleSelect(e, item._id)}
                          checked={selectedIds.includes(item._id)}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>

                      {/* Card Body */}
                      <div className="space-y-3 mb-4">
                        <div>
                          <label className="text-xs font-medium text-gray-500 uppercase tracking-wider">{t('Party_Name')}</label>
                          <p className="text-sm font-semibold text-gray-900 mt-1">{item.partyName}</p>
                        </div>

                        <div className="grid grid-cols-2 gap-4">
                          <div>
                            <label className="text-xs font-medium text-gray-500 uppercase tracking-wider">{t('Contact_Number')}</label>
                            <p className="text-sm text-gray-900 mt-1">{item.contactNumber || '-'}</p>
                          </div>
                          <div>
                            <label className="text-xs font-medium text-gray-500 uppercase tracking-wider">{t('Event_Date')}</label>
                            <p className="text-sm text-gray-900 mt-1">{moment(item.eventDate).format('DD-MM-YYYY')}</p>
                          </div>
                        </div>

                        <div>
                          <label className="text-xs font-medium text-gray-500 uppercase tracking-wider">{t('Farm_Name')}</label>
                          <p className="text-sm text-gray-900 mt-1">{item?.farm?.farmName || '-'}</p>
                        </div>
                      </div>

                      {/* Card Footer - Action Buttons */}
                      <div className="flex items-center justify-end gap-2 pt-4 border-t border-gray-200">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedOrder(item);
                            navigate('/order-details', { state: { selectedOrder: item } });
                          }}
                          className="p-2 text-blue-600 bg-blue-50 rounded-md transition-all duration-200 border border-blue-300 hover:bg-blue-100"
                          title="View Details"
                        >
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                          </svg>
                        </button>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsEdit(true);
                            setIsEditItem(item);
                            handleOpenPopup(true);
                          }}
                          className="p-2 text-green-600 bg-green-50 rounded-md transition-all duration-200 border border-green-300 hover:bg-green-100"
                          title="Edit Order"
                        >
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                          </svg>
                        </button>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsDeleteOrder(item);
                            setisOpenDelete(true);
                          }}
                          className="p-2 text-red-600 bg-red-50 rounded-md transition-all duration-200 border border-red-300 hover:bg-red-100"
                          title="Delete Order"
                        >
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <NoDataFound text={t('no_orders_found')} icon={<NDOrderI />} showButton buttonText={t('add_your_first_order')} handleClick={handleOpenPopup} iconClass="bg-gray-0 mb-0 rounded-none w-auto h-auto" />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {isOpenDelete && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white">
            <div className="mt-3 text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
                <LowStockIcon className='w-6 h-6 text-red-600' />
              </div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">Delete Order</h3>
              <p className="text-sm text-gray-500 mb-6">Are you sure you want to delete this order? This action cannot be undone.</p>
              <div className="flex gap-3">
                <ButtonWithIcon variant='secondary' text='Cancel' btnclass='flex-1 focus:outline-none text-gray-700 bg-gray-100 border border-gray-300 hover:bg-gray-200' onClick={() => onDeleteClose()} />
                <ButtonWithIcon variant='secondary' text='Delete' btnclass='flex-1 bg-red-600 hover:bg-red-700' onClick={() => onDeleteClose(true)} />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add/Edit Order Modal */}
      {isPopupOpen && (
        <AddOrder
          isOpen={isPopupOpen}
          onClose={handleClosePopup}
          isEdit={isEdit}
          isEditItem={isEditItem}
        />
      )}

      {/* Order Details Modal */}
      {isOrderDetailsPopupOpen && (
        <OrderDetails
          isOpen={isOrderDetailsPopupOpen}
          onClose={handleCloseOrderDetailsPopup}
          selectedOrder={selectedOrder}
        />
      )}

      <div ref={printRef} className="hidden" dangerouslySetInnerHTML={{ __html: htmlContent }} />
    </>
  );
};

export default Orders;
